"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mixpanel", {
  enumerable: true,
  get: function get() {
    return _mixpanelBrowser["default"];
  }
});
exports.useMixpanel = exports.withMixpanel = exports.MixpanelConsumer = exports.MixpanelProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MixpanelContext = (0, _react.createContext)(_mixpanelBrowser["default"]);

var MixpanelProvider = function MixpanelProvider(_ref) {
  var children = _ref.children;
  return _react["default"].createElement(MixpanelContext.Provider, {
    value: _mixpanelBrowser["default"]
  }, children);
};

exports.MixpanelProvider = MixpanelProvider;

var MixpanelConsumer = function MixpanelConsumer(_ref2) {
  var children = _ref2.children;
  return _react["default"].createElement(MixpanelContext.Consumer, null, function (mixpanel) {
    return (0, _react.cloneElement)(children, {
      mixpanel: mixpanel
    });
  });
};

exports.MixpanelConsumer = MixpanelConsumer;

var withMixpanel = function withMixpanel() {
  return function (WrappedComponent) {
    var WithMixpanel =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(WithMixpanel, _PureComponent);

      function WithMixpanel() {
        _classCallCheck(this, WithMixpanel);

        return _possibleConstructorReturn(this, _getPrototypeOf(WithMixpanel).apply(this, arguments));
      }

      _createClass(WithMixpanel, [{
        key: "render",
        value: function render() {
          return _react["default"].createElement(MixpanelConsumer, null, _react["default"].createElement(WrappedComponent, _extends({
            ref: this.props.forwardedRef
          }, this.props)));
        }
      }]);

      return WithMixpanel;
    }(_react.PureComponent);

    return _react["default"].forwardRef(function (props, ref) {
      return _react["default"].createElement(WithMixpanel, _extends({}, props, {
        forwardedRef: ref
      }));
    });
  };
};

exports.withMixpanel = withMixpanel;

var useMixpanel = function useMixpanel() {
  return (0, _react.useContext)(MixpanelContext);
};

exports.useMixpanel = useMixpanel;